"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var PropTypes = require("prop-types");
var classnames_1 = require("classnames");
var icon_1 = require("../icon");
var label_1 = require("../label");
var Breadcrumbs = /** @class */ (function (_super) {
    tslib_1.__extends(Breadcrumbs, _super);
    function Breadcrumbs(props, context) {
        return _super.call(this, props, context) || this;
    }
    Breadcrumbs.prototype.renderBreadcrumb = function (breadcrumb, index) {
        var _a;
        if (!breadcrumb.label && !breadcrumb.iconName) {
            return null;
        }
        var theme = this.props.theme;
        var classes = classnames_1.default(theme.breadcrumb, breadcrumb.className, (_a = {},
            _a[theme.separator] = index > 0,
            _a[theme.primary] = breadcrumb.primary,
            _a[theme.clickable] = breadcrumb.onClick,
            _a));
        var labelProps = {
            uppercase: true,
            className: theme.label,
            monserrat: true,
            size: 15,
            weight: 500
        };
        if (breadcrumb.primary) {
            labelProps.weight = 600;
        }
        if (breadcrumb.onClick) {
            labelProps.onClick = breadcrumb.onClick;
        }
        var label = breadcrumb.label;
        if (breadcrumb.link && this.context.linkComponent) {
            var LinkComponent = this.context.linkComponent;
            label = React.createElement(LinkComponent, tslib_1.__assign({}, breadcrumb.link), breadcrumb.label);
        }
        return (React.createElement("li", { key: index, className: classes },
            breadcrumb.iconName ? React.createElement(icon_1.Icon, { className: theme.icon, iconName: breadcrumb.iconName, size: 2.6 }) : null,
            breadcrumb.label ? React.createElement(label_1.Label, tslib_1.__assign({}, labelProps), label) : null));
    };
    Breadcrumbs.prototype.render = function () {
        var _this = this;
        var _a = this.props, theme = _a.theme, className = _a.className, breadcrumbs = _a.breadcrumbs;
        var classes = classnames_1.default(theme.breadcrumbs, className);
        return (React.createElement("ul", { className: classes }, breadcrumbs.map(function (breadcrumb, index) { return _this.renderBreadcrumb(breadcrumb, index); })));
    };
    Breadcrumbs.defaultProps = {
        breadcrumbs: []
    };
    Breadcrumbs.contextTypes = {
        linkComponent: PropTypes.any
    };
    return Breadcrumbs;
}(React.Component));
exports.default = Breadcrumbs;
